import React from "react";
import { Autocomplete, CircularProgress, TextField, Typography } from "@mui/material";
import { Padding, PaletaColor } from "../styles/StylesConstantes";
import { optionsCuponesAnulados } from "../constantes/constantes";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';


function FitrosCanjesComponents({
    title, fechaInicio, handleFechaInicio, fechaFin, handleFechaFin,
    dataUsuarios, loadingCargarName, nameSelected, handleUsuarioNameSearch, handleNameSelected,
    compraManualSelected, handleComprasManualSearch, handleComprasManualSelected,
    dataLocales, loadingCargarLocales, localesSelected, handleLocalSelected, handleSearchLocal
}) {






    return (
        <div style={{
            backgroundColor: PaletaColor.BLANCO,
            borderRadius: Padding.P1,
            padding: Padding.P3,
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant={'h5'} style={{}}>
                    {title}
                </Typography>
            </div>


            <div style={{ marginTop: Padding.P1 }} >
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                    <div style={{}}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Desde
                            </Typography>
                        </div>

                        <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Fecha desde"
                                value={fechaInicio}
                                onChange={(newValue) => {
                                    handleFechaInicio(newValue);
                                }}
                                format="DD/MM/YYYY"
                                sx={{ width: 400 }}
                            />
                        </LocalizationProvider>
                    </div>

                    <div style={{ marginLeft: Padding.P3 }}>
                        <div style={{}}>
                            <div>
                                <Typography variant={'subtitle1'} style={{}}>
                                    Hasta
                                </Typography>
                            </div>

                            <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>

                                <DatePicker
                                    label="Fecha hasta"
                                    value={fechaFin}
                                    onChange={(newValue) => {
                                        handleFechaFin(newValue);
                                    }}
                                    format="DD/MM/YYYY"
                                    sx={{ width: 400 }}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>

                    <div style={{ marginLeft: Padding.P3 }}>
                        <div style={{}}>
                            <div>
                                <Typography variant={'subtitle1'} style={{}}>
                                    Usuario
                                </Typography>
                            </div>

                            <Autocomplete

                                disablePortal
                                options={dataUsuarios}
                                sx={{ width: 400 }}
                                // renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                loading={loadingCargarName}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Seleccione"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {loadingCargarName ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                                onInputChange={(event, newInputValue, reason) => {
                                    if (reason === 'input') {
                                        console.log("reason.........>>", reason);
                                        handleUsuarioNameSearch(newInputValue);
                                    }
                                }}
                                onChange={(a, b) => {
                                    handleNameSelected(b);
                                }}
                                value={nameSelected}
                                getOptionLabel={(option) => option?.value || ''}
                                // isOptionEqualToValue={(option, value) => option?.id === value?.id} // Comparar por ID
                                getOptionKey={(option) => option.id}
                                loadingText={'Cargando...'}
                                noOptionsText={'No hay opciones'}

                            />
                        </div>
                    </div>

                </div>


                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: Padding.P3 }}>
                    <div style={{}}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Local
                            </Typography>
                        </div>

                        <Autocomplete
                            disablePortal
                            options={dataLocales}
                            sx={{ width: 400 }}
                            loading={loadingCargarLocales}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Seleccione"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loadingCargarLocales ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                    handleSearchLocal(newInputValue);
                                }
                            }}
                            onChange={(a, b) => {
                                handleLocalSelected(b);
                            }}
                            value={localesSelected || null}
                            getOptionLabel={(option) => option?.nombre_fantasia || ''}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id} // Comparar por ID
                            getOptionKey={(option) => option.id}
                            loadingText={'Cargando...'}
                            noOptionsText={'No hay opciones'}
                        />
                    </div>
                </div>

            </div>

        </div >
    )
}

export default FitrosCanjesComponents;